import {Card, Divider} from 'antd';
import PropTypes from 'prop-types';

const ExpertiseScreen = ({data}) => {
  return (
    <div className={'w-full flex flex-col justify-center items-center lg:px-20 px-5 lg:py-20 py-10'}>
      <div className={'max-w-7xl'}>
        <div className={'w-full'}>
          <h1 className={'playfair-display-medium font-bold lg:text-6xl text-4xl text-secondary-300'}>{data.title}</h1>
          <p className={'playfair-display-medium lg:text-2xl text-lg mt-3'}>{data.description}</p>
        </div>
        <div className={'grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-5 xl:gap-10 mt-5 '}>
          {data.valuePillars.map((pillar, index) => (
            <Card
              key={index}
              className={'w-full shadow-md min-h-[250px] rounded-3xl flex flex-col justify-between bg-primary-200'}
            >
              <h5 className={'text-xl text-wrap text-center py-2 font-serif min-h-[70px] font-semibold text-secondary-300'}>
                {pillar.title}
              </h5>
              <Divider className={'my-1 border-black'} />
              <p className={'text-base flex-1 mt-2 text-justify'}>{pillar.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

ExpertiseScreen.propTypes = {
  data: PropTypes.shape,
};

export default ExpertiseScreen;
